import { render } from "./ProfileFamily.vue?vue&type=template&id=2a7082df"
import script from "./ProfileFamily.vue?vue&type=script&lang=js"
export * from "./ProfileFamily.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/mkssg/mkssg/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__